// Translation
import { useTranslation } from "react-i18next";

// Material UI
import {
  Button,
  CircularProgress,
  Dialog,
  DialogContentText,
  Stack,
  Typography,
} from "@mui/material";

const ConfirmModal = ({
  open,
  onClose,
  onConfirm,
  loading = false,
  translationKey,
}) => {
  const { t } = useTranslation();

  const handleDialogClose = (event, reason) => {
    if (loading && (reason === "backdropClick" || reason === "escapeKeyDown")) {
      return;
    }
    onClose(event, reason);
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      disableEscapeKeyDown={loading}
      sx={{ minWidth: "300px" }}
      slotProps={{ paper: { sx: { p: 3, m: 0 } } }}
      maxWidth="sm"
      fullWidth
    >
      <Stack spacing={2} sx={{ boxSizing: "border-box" }}>
        <Typography
          color="primary"
          sx={{ fontWeight: "bold", fontSize: "1.25rem" }}
        >
          {t(`${translationKey}.title`)}
        </Typography>
        <DialogContentText>{t(`${translationKey}.message`)}</DialogContentText>
        <Stack
          direction={{ xs: "column-reverse", sm: "row" }}
          spacing={2}
          sx={{
            justifyContent: { xs: "stretch", sm: "flex-end" },
            alignItems: "center",
          }}
        >
          <Button variant="text" onClick={handleDialogClose} disabled={loading}>
            {t(`${translationKey}.no`)}
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            disabled={loading}
            startIcon={
              loading && <CircularProgress size="14px" color="inherit" />
            }
            sx={{
              width: { xs: "100%", sm: "fit-content" },
              minWidth: "10rem",
            }}
          >
            {loading
              ? t(`${translationKey}.loading`)
              : t(`${translationKey}.yes`)}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default ConfirmModal;
